/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dns_Records_Not_Yet_DetectedInputs */

const en_dns_records_not_yet_detected = /** @type {(inputs: Dns_Records_Not_Yet_DetectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DNS records not yet detected.`)
};

const es_dns_records_not_yet_detected = /** @type {(inputs: Dns_Records_Not_Yet_DetectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registros DNS aún no detectados.`)
};

const fr_dns_records_not_yet_detected = /** @type {(inputs: Dns_Records_Not_Yet_DetectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enregistrements DNS non encore détectés.`)
};

const de_dns_records_not_yet_detected = /** @type {(inputs: Dns_Records_Not_Yet_DetectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DNS-Einträge noch nicht erkannt.`)
};

const ja_dns_records_not_yet_detected = /** @type {(inputs: Dns_Records_Not_Yet_DetectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DNSレコードがまだ検出されていません。`)
};

const zh_dns_records_not_yet_detected = /** @type {(inputs: Dns_Records_Not_Yet_DetectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`尚未检测到 DNS 记录。`)
};

const ar_dns_records_not_yet_detected = /** @type {(inputs: Dns_Records_Not_Yet_DetectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لم يتم اكتشاف سجلات DNS بعد.`)
};

const id_dns_records_not_yet_detected = /** @type {(inputs: Dns_Records_Not_Yet_DetectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rekaman DNS belum terdeteksi.`)
};

const it_dns_records_not_yet_detected = /** @type {(inputs: Dns_Records_Not_Yet_DetectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Record DNS non ancora rilevati.`)
};

const ru_dns_records_not_yet_detected = /** @type {(inputs: Dns_Records_Not_Yet_DetectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Записи DNS еще не обнаружены.`)
};

const pt_dns_records_not_yet_detected = /** @type {(inputs: Dns_Records_Not_Yet_DetectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registros DNS ainda não detectados.`)
};

const ko_dns_records_not_yet_detected = /** @type {(inputs: Dns_Records_Not_Yet_DetectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DNS 레코드가 아직 감지되지 않았습니다.`)
};

/**
* | output |
* | --- |
* | "DNS records not yet detected." |
*
* @param {Dns_Records_Not_Yet_DetectedInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const dns_records_not_yet_detected = /** @type {((inputs?: Dns_Records_Not_Yet_DetectedInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dns_Records_Not_Yet_DetectedInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dns_records_not_yet_detected(inputs)
	if (locale === "es") return es_dns_records_not_yet_detected(inputs)
	if (locale === "fr") return fr_dns_records_not_yet_detected(inputs)
	if (locale === "de") return de_dns_records_not_yet_detected(inputs)
	if (locale === "ja") return ja_dns_records_not_yet_detected(inputs)
	if (locale === "zh") return zh_dns_records_not_yet_detected(inputs)
	if (locale === "ar") return ar_dns_records_not_yet_detected(inputs)
	if (locale === "id") return id_dns_records_not_yet_detected(inputs)
	if (locale === "it") return it_dns_records_not_yet_detected(inputs)
	if (locale === "ru") return ru_dns_records_not_yet_detected(inputs)
	if (locale === "pt") return pt_dns_records_not_yet_detected(inputs)
	return ko_dns_records_not_yet_detected(inputs)
});